// extracted by mini-css-extract-plugin
export var borderRadius = "_as-4";
export var large = "_as-3";
export var logoContainer = "_as-0";
export var nameLogo = "_as-2";
export var small = "_as-1";